import { trapFocus, removeTrapFocus } from "./utils.js";

const selectors = {
  cartDrawerToggle: '[data-selector="cart-drawer-toggle"]',
  cartDrawerBackdrop: '[data-selector="cart-drawer-backdrop"]',
  cartDrawerClose: '[data-selector="cart-drawer-close"]',
  cartDrawerPanel: '[data-selector="cart-drawer-panel"]',
  cartDrawerBody: '[data-selector="cart-drawer-body"]',
};

const classes = {
  open: "open",
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.onToggleCartDrawer = this.onToggleCartDrawer.bind(this);

    this.onOpenEvent = this.onOpenEvent.bind(this);
    this.onCloseEvent = this.onCloseEvent.bind(this);
  }

  connectedCallback() {
    this.cartDrawerToggle = document.querySelector(selectors.cartDrawerToggle);
    this.cartDrawerBackdrop = this.querySelector(selectors.cartDrawerBackdrop);
    this.cartDrawerClose = this.querySelectorAll(selectors.cartDrawerClose);
    this.cartDrawerPanel = this.querySelector(selectors.cartDrawerPanel);
    this.cartDrawerBody = this.querySelector(selectors.cartDrawerBody);

    if (!this.cartDrawerToggle) return;

    this.initCartDrawer();
  }

  disconnectedCallback() {
    if (this.cartDrawerToggle) {
      this.cartDrawerToggle.removeEventListener("click", this.onToggleCartDrawer);
    }

    this.removeEventListener("keyup", this.handleCloseOnEscape);

    if (this.cartDrawerBackdrop) {
      this.cartDrawerBackdrop.removeEventListener("click", this.handleCloseCartDrawer);
    }

    if (this.cartDrawerClose?.length) {
      this.cartDrawerClose.forEach((drawerClose) => {
        drawerClose.removeEventListener("click", this.handleCloseCartDrawer);
      });
    }

    document.removeEventListener("cart:open", this.onOpenEvent);
    document.removeEventListener("cart:close", this.onCloseEvent);
  }

  initCartDrawer() {
    this.cartDrawerToggle.addEventListener("click", this.onToggleCartDrawer);

    this.addEventListener("keyup", this.handleCloseOnEscape);

    if (this.cartDrawerBackdrop) {
      this.cartDrawerBackdrop.addEventListener("click", this.handleCloseCartDrawer);
    }

    if (this.cartDrawerClose.length) {
      this.cartDrawerClose.forEach((drawerClose) => {
        drawerClose.addEventListener("click", this.handleCloseCartDrawer);
      });
    }

    document.addEventListener("cart:open", this.onOpenEvent);
    document.addEventListener("cart:close", this.onCloseEvent);
  }

  isOpen() {
    return this.classList.contains(classes.open);
  }

  onToggleCartDrawer(e) {
    e.preventDefault();

    if (this.isOpen()) {
      this.handleCloseCartDrawer();
    } else {
      this.handleOpenCartDrawer();
    }
  }

  onOpenEvent() {
    if (this.isOpen()) return;
    this.handleOpenCartDrawer();
  }

  onCloseEvent() {
    if (!this.isOpen()) return;
    this.handleCloseCartDrawer();
  }

  handleOpenCartDrawer() {
    this.classList.add(classes.open);
    this.setAttribute("aria-hidden", "false");

    document.body.classList.add("no-scroll");

    this.addEventListener(
      "transitionend",
      () => {
        trapFocus(this, this.cartDrawerClose.length ? this.cartDrawerClose[0] : this.cartDrawerPanel);
      },
      { once: true },
    );
  }

  handleCloseCartDrawer = () => {
    this.classList.remove(classes.open);
    this.setAttribute("aria-hidden", "true");

    removeTrapFocus(this.cartDrawerToggle);

    document.body.classList.remove("no-scroll");
  };

  handleCloseOnEscape = (e) => {
    if (e.code === "Escape") this.handleCloseCartDrawer();
  };
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}
